import { UNLOCK_WSPOS, UNLOCK_WSPOS_SUCCESSFUL, UNLOCK_WSPOS_FAILED } from './actionTypes';

export const unlockWSPosition = (wspos, token, history) => {
    return {
        type: UNLOCK_WSPOS,
        payload: { wspos, token, history }
    }
}

export const unlockWSPositionSuccessful = (msg) => {
    return {
        type: UNLOCK_WSPOS_SUCCESSFUL,
        payload: msg
    }
}

export const unlockWSPositionFailed = (msg) => {
    return {
        type: UNLOCK_WSPOS_FAILED,
        payload: msg
    }
}
